import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentClassificationHeader from "./document-classification-header";
import DocumentClassificationBody from "./document-classification-body";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationCollapse",
  components: {
    DocumentClassificationHeader,
    DocumentClassificationBody
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    classification: {
      type: Object,
      required: true
    },
    documents: {
      type: Object,
      required: true
    },
    comments: {
      type: Object,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapseVisible: false
    };
  },
  computed: {
    documentRequestId() {
      return this.classification.documentRequestId;
    },
    documentsInClassification() {
      var _context;
      return _reduceInstanceProperty(_context = this.classification.documents).call(_context, (acc, documentId) => {
        acc.byId[documentId] = this.documents.byId[documentId];
        return acc;
      }, {
        byId: {}
      });
    }
  }
});